<mat-form-field appearance="fill">
    <mat-label>{{ placeholder | translate }} <ng-container *ngIf="required">*</ng-container></mat-label>
    <mat-select
        [formControl]="control"
        [id]="id"
        (selectionChange)="selected.emit($event.value)"
        [class.no-arrow-icon]="icon">
        <mat-option *ngFor="let option of options" [value]="option.value" [id]="id + '-' + option.value">
            {{ option.label | translate}}
        </mat-option>
    </mat-select>
    <span *ngIf="icon" matSuffix class="icon {{ icon }}"></span>
    <mat-error *ngIf="control.hasError('required')">
        {{ 'ERRORS.FIELD_IS_REQUIRED' | translate }}
    </mat-error>
</mat-form-field>
